/*!
 * PXG Australia – custom build grouping for Dawn's cart drawer + cart page (NEW file, not Dawn core).
 * A configurator build = 1 head line (qty = clubs) + upgrade lines (qty = clubs), linked by the _build_id property.
 * - Upgrade lines are shown as part of the build (no quantity / remove controls).
 * - Head line quantity is fixed; removing it removes the whole build.
 * - Any build that no longer matches what the configurator added (or a build line added some other way)
 *   is removed and the customer is asked to rebuild. Pricing logic: pxg-config-engine.js auditCart().
 */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var running = false, queued = false, observer = null, cartCache = null;

  function json(url, body) {
    return fetch(root + url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function rowsFor(index) { return document.querySelectorAll('#CartDrawer-Item-' + index + ', #CartItem-' + index); }
  function sectionsToRender() {
    var s = ['cart-icon-bubble', 'cart-live-region-text'];
    if (document.querySelector('cart-drawer')) s.push('cart-drawer');
    if (document.getElementById('main-cart-items')) location.pathname.indexOf('/cart') >= 0 && s.push('main-cart-items', 'main-cart-footer');
    return s;
  }

  function removeLines(keys, notice) {
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return json('cart/update.js', { updates: updates, sections: sectionsToRender().join(','), sections_url: location.pathname }).then(function (res) {
      if (notice) sessionStorageSafe('pxg-cart-notice', notice);
      var drawer = document.querySelector('cart-drawer');
      if (location.pathname.replace(root, '/').indexOf('/cart') === 0 && !drawer) { location.reload(); return; }
      if (drawer && res.sections && typeof drawer.renderContents === 'function') {
        if (!res.item_count) { var inner = drawer.querySelector('.drawer__inner'); if (inner) inner.classList.add('is-empty'); }
        drawer.renderContents(res);
      }
      if (document.getElementById('main-cart-items')) location.reload();
    });
  }
  function sessionStorageSafe(k, v) { try { if (v === undefined) { var x = sessionStorage.getItem(k); sessionStorage.removeItem(k); return x; } sessionStorage.setItem(k, v); } catch (e) { return null; } }

  function showNotice(msg) {
    if (!msg) return;
    document.querySelectorAll('cart-drawer-items, cart-items, #main-cart-items').forEach(function (box) {
      if (box.querySelector('.pxg-cart-notice')) return;
      var p = document.createElement('p');
      p.className = 'pxg-cart-notice'; p.setAttribute('role', 'status'); p.textContent = msg;
      box.insertBefore(p, box.firstChild);
    });
  }

  function decorate(cart) {
    var builds = {};
    cart.items.forEach(function (it, i) {
      var p = it.properties || {};
      if (!p._build_id) return;
      (builds[p._build_id] = builds[p._build_id] || []).push({ it: it, index: i + 1 });
    });
    Object.keys(builds).forEach(function (id) {
      builds[id].forEach(function (x) {
        var role = (x.it.properties || {})._role;
        rowsFor(x.index).forEach(function (row) {
          if (row.getAttribute('data-pxg-build') === id + role + x.it.quantity) return;
          row.setAttribute('data-pxg-build', id + role + x.it.quantity);
          row.classList.add('pxg-line', role === 'head' ? 'pxg-line--head' : 'pxg-line--upgrade');
          var qtyCell = row.querySelector('.cart-item__quantity');
          if (!qtyCell) return;
          var wrap = qtyCell.querySelector('.cart-item__quantity-wrapper') || qtyCell;
          var input = wrap.querySelector('quantity-input, quantity-popover');
          if (input) input.classList.add('pxg-hidden');
          var label = wrap.querySelector('.pxg-line__qty');
          if (!label) { label = document.createElement('span'); label.className = 'pxg-line__qty'; (input ? input.parentNode : wrap).insertBefore(label, input ? input.nextSibling : null); }
          label.textContent = role === 'head' ? (x.it.quantity === 1 ? '1 club' : x.it.quantity + ' clubs') : '× ' + x.it.quantity;
          var rm = row.querySelector('cart-remove-button');
          if (rm) { rm.setAttribute('data-pxg-build-id', id); rm.classList.toggle('pxg-hidden', role !== 'head'); }
        });
      });
    });
  }

  function run() {
    if (running) { queued = true; return; }
    running = true;
    json('cart.js').then(function (cart) {
      cartCache = cart;
      var E = window.PXGEngine;
      var broken = E ? E.auditCart(cart.items) : [];
      if (broken.length) {
        var keys = [];
        broken.forEach(function (b) { keys = keys.concat(b.lines); });
        return removeLines(keys, 'A custom club build in your cart was changed, so we removed it. Please rebuild it from the product page.');
      }
      pause(); decorate(cart); showNotice(sessionStorageSafe('pxg-cart-notice')); resume();
    }).catch(function () {}).then(function () {
      running = false;
      if (queued) { queued = false; schedule(); }
    });
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(run, 120); }
  function pause() { if (observer) observer.disconnect(); }
  function resume() {
    if (!observer) observer = new MutationObserver(schedule);
    document.querySelectorAll('cart-drawer, cart-items, #main-cart-items, cart-drawer-items').forEach(function (el) { observer.observe(el, { childList: true, subtree: true }); });
  }

  // Removing a build's head removes the whole build (capture phase, before Dawn's own handler).
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('cart-remove-button[data-pxg-build-id]');
    if (!rm) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var id = rm.getAttribute('data-pxg-build-id');
    var keys = (cartCache ? cartCache.items : []).filter(function (it) { return (it.properties || {})._build_id === id; }).map(function (it) { return it.key; });
    if (keys.length) removeLines(keys);
  }, true);

  document.addEventListener('pxg:build-added', schedule);
  function boot() { resume(); run(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
